"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
var _text = require("@oneloop/text");
var _icons = require("@oneloop/icons");
var _excluded = ["variant", "text", "closeAlert"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Alert = exports.Alert = function Alert(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'info' : _ref$variant,
    text = _ref.text,
    closeAlert = _ref.closeAlert,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Flex, _extends({
    tx: "alert",
    variant: variant
  }, props, {
    __css: {
      borderRadius: '12px',
      padding: '20px 24px',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between'
    }
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "body.fontSize11",
    display: "flex",
    alignItems: "center",
    flexGrow: 1
  }, text), /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: "icon-cerrar",
    fontSize: "12px",
    style: {
      cursor: 'pointer'
    },
    onClick: closeAlert
  }));
};